<div class="bg-gradient-primary">
    <div class="container">
      <!-- Outer Row -->
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-9">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <!-- Nested Row within Card Body -->
              <div class="row">
                <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div class="col-lg-6">
                  <div class="p-5">
                    <div class="text-center">
                      <div>
                        <img
                          style="object-fit: cover"
                          src="assets/img/logo.png"
                        />
                        <br /><br />
                      </div>
                      <h1 class="h4 text-gray-900 mb-4">Tạo tài khoản!</h1>
                    </div>

                    <!-- <form class="user">
                        <div class="form-group row">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <input type="text" class="form-control form-control-user" id="exampleFirstName" placeholder="First Name">
                            </div>
                            <div class="col-sm-6">
                                <input type="text" class="form-control form-control-user" id="exampleLastName" placeholder="Last Name">
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-control form-control-user" id="exampleInputEmail" placeholder="Email Address">
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <input type="password" class="form-control form-control-user" id="exampleInputPassword" placeholder="Password">
                            </div>
                            <div class="col-sm-6">
                                <input type="password" class="form-control form-control-user" id="exampleRepeatPassword" placeholder="Repeat Password">
                            </div>
                        </div>
                        <a href="login.html" class="btn btn-primary btn-user btn-block">
                            Register Account
                        </a>
                        <hr>
                      
                    </form> -->

                    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate class="user">
                      <div class="form-group row">
                          <div class="col-sm-6 mb-3 mb-sm-0">
                              <input type="text" formControlName="firstName" class="form-control form-control-user" id="exampleFirstName"
                                     placeholder="Họ"
                                     [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
                              <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                  <div *ngIf="f.firstName.errors.required">Họ là bắt buộc</div>
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <input type="text" formControlName="lastName" class="form-control form-control-user" id="exampleLastName"
                                     placeholder="Tên"
                                     [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                              <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                  <div *ngIf="f.lastName.errors.required">Tên là bắt buộc</div>
                              </div>
                          </div>
                      </div>
                      
                      <div class="form-group">
                          <input type="email" formControlName="email" class="form-control form-control-user" id="exampleInputEmail"
                                 placeholder="Địa chỉ email"
                                 [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                          <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                              <div *ngIf="f.email.errors.required">Email là bắt buộc</div>
                              <div *ngIf="f.email.errors.email">Vui lòng nhập email hợp lệ</div>
                          </div>
                      </div>
                      
                      <!-- Trường tên đăng nhập -->
                      <div class="form-group">
                          <input type="text" formControlName="username" class="form-control form-control-user" id="exampleInputUsername"
                                 placeholder="Tên đăng nhập"
                                 [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                              <div *ngIf="f.username.errors.required">Tên đăng nhập là bắt buộc</div>
                          </div>
                      </div>
                  
                      <div class="form-group row">
                          <div class="col-sm-6 mb-3 mb-sm-0">
                              <input type="password" formControlName="password" class="form-control form-control-user" id="exampleInputPassword"
                                     placeholder="Mật khẩu"
                                     [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                              <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                  <div *ngIf="f.password.errors.required">Mật khẩu là bắt buộc</div>
                                  <div *ngIf="f.password.errors.minlength">Mật khẩu phải có ít nhất 6 ký tự</div>
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <input type="password" formControlName="confirmPassword" class="form-control form-control-user" id="exampleRepeatPassword"
                                     placeholder="Nhập lại mật khẩu"
                                     [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                              <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                  <div *ngIf="f.confirmPassword.errors.required">Xác nhận mật khẩu là bắt buộc</div>
                                  <div *ngIf="f.confirmPassword.errors.mustMatch">Mật khẩu không khớp</div>
                              </div>
                          </div>
                      </div>
                      
                      <div class="form-group">
                          <input type="text" formControlName="phoneNumber" class="form-control form-control-user" id="examplePhoneNumber"
                                 placeholder="Số điện thoại (Không bắt buộc)" />
                      </div>
                  
                      <button type="submit" class="btn btn-primary btn-user btn-block">
                        <i class="fas fa-user-plus"></i> Đăng ký tài khoản
                      </button>
                      <hr>
                  </form>
                  
                  
                  
                  <div class="text-center">
                    <a class="small" routerLink="/login">Đăng nhập!</a>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
